module.exports = __webpack_public_path__ + "static/media/tutorial-banner.3903caf5.jpg";